import { createStore } from "vuex";
import axios from "axios";
import Constants from "./constants.js";
// import filter from "lodash/filter";
const today = new Date();
const store = createStore({
  state() {
    return {
      hasCDL: "",
      planInterest: "",       // 'CDL' | 'Identity Defender' | 'Both'
      whoFor: "",             // 'Yourself' | 'You and your family'
      plan_questions_complete: false,
      checkout_started: false,
      isSEIU: "yes",
      isFAM: "yes",
      cdl_plan: false,
      jwt_token: "",
      referer_url: "",
      company: {},
      next_month: "",
      company_number: "",
      occupations: [
        {
          "key": "administration",
          "value": "Administration"
        },
        {
          "key": "athletics",
          "value": "Athletics"
        },
        {
          "key": "business_services",
          "value": "Business Services"
        },
        {
          "key": "career_technical",
          "value": "Career & Technical Education"
        },
        {
          "key": "educator",
          "value": "Educator"
        },
        {
          "key": "food_services",
          "value": "Food Services"
        },
        {
          "key": "maintenance",
          "value": "Maintenance"
        },
        {
          "key": "office",
          "value": "Office/Clerical"
        },
        {
          "key": "technology",
          "value": "Technology"
        },
        {
          "key": "transportation",
          "value": "Transportation"
        },
        {
          "key": "other",
          "value": "Other"
        }
      ],
      branches: [
        {
          "key": "online",
          "value": "Online Access mostly/only"
        },
        {
          "key": "brenham",
          "value": "Brenham"
        },
        {
          "key": "college_station",
          "value": "College Station"
        },
        {
          "key": "cross_creek",
          "value": "Cross Creek Ranch"
        },
        {
          "key": "fort_bend",
          "value": "Fort Bend ISD Career & Technology Center"
        },
        {
          "key": "katy_kingsland",
          "value": "Katy - Kingsland Blvd."
        },
        {
          "key": "katy_saums",
          "value": "Katy - Saums Road "
        },
        {
          "key": "missouri_city",
          "value": "Missouri City"
        },
        {
          "key": "first_street",
          "value": "Rosenberg - First Street"
        },
        {
          "key": "mustang_avenue",
          "value": "Rosenberg - Mustang Avenue"
        },
        {
          "key": "sealy",
          "value": "Sealy"
        },
        {
          "key": "sugar_land",
          "value": "Sugar Land"
        },
        {
          "key": "waller",
          "value": "Waller"
        }
      ],
      company_emails: "",
      ssn_required: "0",
      employee_id_required:"0",
      companies: [],
      payment_options: "",
      bundled_group: [],
      bank_branch: "",
      enroll_msg: false,
      payment_method: "",
      payment_frequency: "",
      plan_grp: { price: "0.00" },
      service_fee: "02.00",
      disp_flag: false,
      last_day_month: "",
      enroll_option: "",
      opt_type: "",
      opt_value: "",
      payroll_enrollment: "0",
      show_payment: false,
      show_cc_label: false,
      show_payroll_label: false,
      show_payroll_enrollment_label: false,
      eligibilityMessage: "You must have a Commercial Driver's License to be eligible to enroll in the CDL Defender plan.",
      eff_date: today,
      enrollment_settings: {
        effective_date_cutoff: '',
        effective_date_after_enrollment:'',
        disclaimer_text: ``,
        e_sign_text: ``,
        closed_enroll_period_message: '',
        open_enrollment_start_date: '',
        open_enrollment_end_date: ''
      },
      member: {
        spouse_name: "",
        first_name: "",
        last_name: "",
        employee_id: "",
        creditCardHolder: "",
        cc_type: "visa",
        cc: "",
        exp_month: "",
        ccv: "",
        eSignature: "",
        iagree: "",
        occupation:"",
        other_occupation:"",
        bank_branch:"",
        billingZip:"",
        gender:"Male",
        mdsId:"",
        seaName:"",
        seaNumber:"",
        seiuLocalName:"",
        seiuLocalNumber:"",
        ssn: "",
        email: "",
        phone: "",
        cell: "false",
        address: null,
        address1: "",
        address2: "",
        city: "",
        state: "",
        county:"",
        zip: "",
        date_of_birth: null,
        driv_license: "",
        driv_lic_state: "",
        mi:"",
        work_phone:"",
        employer_name:""
      },
      total_monthly_prem: 0,
      total_prorated_prem: 0,
      prorated_premium: "0.00",
      total: "0.00",
      states: [
        {
          name: "Alabama",
          abbreviation: "AL",
        },
        {
          name: "Alaska",
          abbreviation: "AK",
        },
        {
          name: "American Samoa",
          abbreviation: "AS",
        },
        {
          name: "Arizona",
          abbreviation: "AZ",
        },
        {
          name: "Arkansas",
          abbreviation: "AR",
        },
        {
          name: "California",
          abbreviation: "CA",
        },
        {
          name: "Colorado",
          abbreviation: "CO",
        },
        {
          name: "Connecticut",
          abbreviation: "CT",
        },
        {
          name: "Delaware",
          abbreviation: "DE",
        },
        {
          name: "District Of Columbia",
          abbreviation: "DC",
        },
        {
          name: "Federated States Of Micronesia",
          abbreviation: "FM",
        },
        {
          name: "Florida",
          abbreviation: "FL",
        },
        {
          name: "Georgia",
          abbreviation: "GA",
        },
        {
          name: "Guam",
          abbreviation: "GU",
        },
        {
          name: "Hawaii",
          abbreviation: "HI",
        },
        {
          name: "Idaho",
          abbreviation: "ID",
        },
        {
          name: "Illinois",
          abbreviation: "IL",
        },
        {
          name: "Indiana",
          abbreviation: "IN",
        },
        {
          name: "Iowa",
          abbreviation: "IA",
        },
        {
          name: "Kansas",
          abbreviation: "KS",
        },
        {
          name: "Kentucky",
          abbreviation: "KY",
        },
        {
          name: "Louisiana",
          abbreviation: "LA",
        },
        {
          name: "Maine",
          abbreviation: "ME",
        },
        {
          name: "Marshall Islands",
          abbreviation: "MH",
        },
        {
          name: "Maryland",
          abbreviation: "MD",
        },
        {
          name: "Massachusetts",
          abbreviation: "MA",
        },
        {
          name: "Michigan",
          abbreviation: "MI",
        },
        {
          name: "Minnesota",
          abbreviation: "MN",
        },
        {
          name: "Mississippi",
          abbreviation: "MS",
        },
        {
          name: "Missouri",
          abbreviation: "MO",
        },
        {
          name: "Montana",
          abbreviation: "MT",
        },
        {
          name: "Nebraska",
          abbreviation: "NE",
        },
        {
          name: "Nevada",
          abbreviation: "NV",
        },
        {
          name: "New Hampshire",
          abbreviation: "NH",
        },
        {
          name: "New Jersey",
          abbreviation: "NJ",
        },
        {
          name: "New Mexico",
          abbreviation: "NM",
        },
        {
          name: "New York",
          abbreviation: "NY",
        },
        {
          name: "North Carolina",
          abbreviation: "NC",
        },
        {
          name: "North Dakota",
          abbreviation: "ND",
        },
        {
          name: "Northern Mariana Islands",
          abbreviation: "MP",
        },
        {
          name: "Ohio",
          abbreviation: "OH",
        },
        {
          name: "Oklahoma",
          abbreviation: "OK",
        },
        {
          name: "Oregon",
          abbreviation: "OR",
        },
        {
          name: "Palau",
          abbreviation: "PW",
        },
        {
          name: "Pennsylvania",
          abbreviation: "PA",
        },
        {
          name: "Puerto Rico",
          abbreviation: "PR",
        },
        {
          name: "Rhode Island",
          abbreviation: "RI",
        },
        {
          name: "South Carolina",
          abbreviation: "SC",
        },
        {
          name: "South Dakota",
          abbreviation: "SD",
        },
        {
          name: "Tennessee",
          abbreviation: "TN",
        },
        {
          name: "Texas",
          abbreviation: "TX",
        },
        {
          name: "Utah",
          abbreviation: "UT",
        },
        {
          name: "Vermont",
          abbreviation: "VT",
        },
        {
          name: "Virgin Islands",
          abbreviation: "VI",
        },
        {
          name: "Virginia",
          abbreviation: "VA",
        },
        {
          name: "Washington",
          abbreviation: "WA",
        },
        {
          name: "West Virginia",
          abbreviation: "WV",
        },
        {
          name: "Wisconsin",
          abbreviation: "WI",
        },
        {
          name: "Wyoming",
          abbreviation: "WY",
        },
      ],
      disp_enroll_section: false,
      disp_err_msg: false,
      disb_submit: true,
      mem_flag: false,
      duplicate_value: false,
      day_diff: 0,
      reset_form:false
    };
  },
  mutations: {
    updateState(state, payload) {
      const keys = payload.key.split("."); // Split the key by dot notation
      let obj = state;

      // Traverse through nested keys except the last one
      keys.slice(0, -1).forEach((key) => {
        if (!obj[key]) {
          obj[key] = {}; // Initialize if the intermediate key doesn't exist
        }
        obj = obj[key];
      });

      // Set the value for the final key
      obj[keys[keys.length - 1]] = payload.value;
    },
  },
  actions: {
    updateState({ commit }, payload) {
      commit("updateState", payload);
    },
    getPlan({ state, commit }, value) {
       if (state.opt_type === "general" && (!state.hasCDL || state.hasCDL === "")) {
          return Promise.resolve({
            status: "Not found",
            error: "Please select whether you have a CDL before continuing."
          });
        }
      document.getElementById("loader").classList.remove("hidden");
      return new Promise((resolve) => {
        axios
          .post(Constants.API_BASE + value.api_name, value, {
            headers: {
              Authorization: state.jwt_token, // Use token from state
            },
          })
          .then((response) => {
            const responseData = response.data.data;
            document.getElementById("loader").classList.add("hidden");
            resolve(responseData); // Resolve with response data

          })
          .catch((error) => {
            console.log(error.response.data.message)
            document.getElementById("loader").classList.add("hidden");
            commit("updateState", { key: "disp_enroll_section", value: false });
            resolve({"status":"Not found","error":error.response.data.message});
          });
      });
    },
    getToken({ commit,state },params) {
      document.getElementById("loader").classList.remove("hidden");
       if (!localStorage.getItem("initial_referrer")) {
        localStorage.setItem(
          "initial_referrer",
          document.referrer || "direct"
        );
      }
      const trackingContext = {
        referrer: document.referrer || null,
        initial_referrer: localStorage.getItem("initial_referrer"),
        userAgent: navigator.userAgent,
        current_url: window.location.href
      };
      return new Promise((resolve, reject) => {
        axios
          .post(Constants.API_BASE + "generateToken", { 
            "userId": "uslenroll11!!",
            "role": "member",
            "iss": "USL Enrollment Portal",
            "opt":state.opt_type,
            "url_obj":params,
            "tracking": trackingContext
            })
          .then((response) => {
            document.getElementById("loader").classList.add("hidden");
            response = response.data;
            if (response.status !== "success") {
              // Reject the promise with the error message if status is not 'success'
              reject(new Error(response.message));
            } else {
              const token = response.data;
              commit("updateState", { key: "jwt_token", value: token }); // Save token to the store
              resolve(response); // Resolve the promise with the token
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    loadCompany({ commit, state }, payload) {
      // document.getElementById("loader").classList.remove("hidden");
      console.log(payload);
      return new Promise((resolve, reject) => {
        axios
          .post(Constants.API_BASE + "getCompanyList", payload, {
            headers: {
              Authorization: state.jwt_token, // Use token from state
            },
          })
          .then((response) => {
            document.getElementById("loader").classList.add("hidden");
            const companies = response.data.data;
            console.log(companies);
            commit("updateState", { key: "companies", value: companies }); // Save companies to the store
            resolve(response); // Resolve the promise with the companies
          })
          .catch((error) => {
            document.getElementById("loader").classList.add("hidden");

            // Reject the promise with the error if the request fails
            reject(
              new Error("Error fetching companies: " + error.message || error)
            );
          });
      });
    },
    createMember({ state }, payload) {
      document.getElementById("loader").classList.remove("hidden");
      const enrollHeaders = {
        Authorization: state.jwt_token,
        token:
          "NDAzYjdjMTctMTQ3NS00NDMyLWI4OWYtZjlkNjljOGZmNWQ3NjM3NTczNDI0MTAwMjI2Mjg1",
      };
      return new Promise((resolve) => {
        axios
          .post(`${Constants.API_BASE}submitEnrollment`, payload, {
            headers: enrollHeaders,
          })
          .then((response) => {
            document.getElementById("loader").classList.add("hidden");
            resolve(response);
          })
          .catch((error) => {
            document.getElementById("loader").classList.add("hidden");
            resolve(error.response);
          });
      });
    },
    getNeaMemberDetails({ state}, payload) {
      return new Promise((resolve, reject) => {
        let member_url = `${Constants.API_BASE}getNeaMemberDetails`;

        axios
          .post(member_url, payload, {
            headers: { Authorization: state.jwt_token },
          })
          .then((response) => {
            console.log(response.data)
            if (response.data.status === "success") {
              resolve(response.data);
            } else {
              reject(new Error(response.data.message));
            }
          })
          .catch((error) => {
            console.error(error);
            reject(new Error(error.message || "An unexpected error occurred."));
          });
      });
    }
  },
});

export default store;
